/* eslint-disable */
import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import './opportunitiesOverviewReport.scss';
import '../WeeklyClosureReport/clouserReport.scss';

import DataGridComponent from '../../../../Components/DataGrid/dataGrid';
import ButtonComponent from '../../../../Components/Button/button';
import DateRangeEditor from '../../../../Components/CustomDateRange/dateRangeInput';
import { useSnackbar } from '../../../../Components/Snackbar/snackBarProvider';

import ArrowDropDownIcon from '../../../../Assets/images/svg/drop-down-arrow.svg';
import ExcelIcon from '../../../../Assets/images/svg/excel.svg';
import ExcelHoverIcon from '../../../../Assets/images/svg/excel_hover.svg';

import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';

import {
  MAP_OPPORTUNITIES_OVERVIEW_FIELDS,
  OPPORTUNITIES_OVERVIEW,
  STAFF_AUGMENTATION,
  DATE_NOTE_HEADING,
  DATE_NOTE_DESCRIPTION,
} from '../../../../Constants/strings';

import { getOpportunitiesOverviewReport } from '../../../../Api/request/reports';
import { defaultDateRanges } from '../defaultDate';

const OpportunitiesOverviewReport = ({
  opportunitiesRows = [],
  initialDateRange,
  opportunitiesDateRange,
  setOpportunitiesDateRange,
  opportunitiesPageSize = 10,
  getOpportunitiesOverviewData,
}) => {
  const [isMobileView, setIsMobileView] = useState(false);
  const [isLaptopView, setIsLaptopView] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isExcelHovered, setIsExcelHovered] = useState(false);

  const { snackbarOpen } = useSnackbar();

  const checkMobileView = useCallback(() => {
    const width = window.innerWidth;
    setIsMobileView(width < 1024);
    setIsLaptopView(width >= 1024 && width <= 1700);
  }, []);

  useEffect(() => {
    checkMobileView();
    window.addEventListener('resize', checkMobileView);
    return () => window.removeEventListener('resize', checkMobileView);
  }, [checkMobileView]);

  // useEffect(() => {
  //   if (initialDateRange) {
  //     setOpportunitiesDateRange(initialDateRange);

  //     if (initialDateRange.startDate && initialDateRange.endDate) {
  //       const formattedStartDate = dayjs(initialDateRange.startDate).format('YYYY-MM-DD');
  //       const formattedEndDate = dayjs(initialDateRange.endDate).format('YYYY-MM-DD');
  //       getOpportunitiesOverviewData(formattedStartDate, formattedEndDate);
  //     }
  //   }
  // }, [initialDateRange]);

  const getColumnWidth = (mobile, laptop, desktop) =>
    isMobileView ? mobile : isLaptopView ? laptop : desktop;

  const columns = [
    {
      field: MAP_OPPORTUNITIES_OVERVIEW_FIELDS.VERTICAL_NAME,
      headerName: OPPORTUNITIES_OVERVIEW.VERTICAL,
      width: getColumnWidth(180, 220, 150),
      minWidth: 180,
      cellClassName: 'table-vertical-column-cell',
    },
    {
      field: MAP_OPPORTUNITIES_OVERVIEW_FIELDS.DEAL_TYPE,
      headerName: OPPORTUNITIES_OVERVIEW.DEAL_TYPE,
      width: getColumnWidth(180, 220, 150),
      minWidth: 180,
      cellClassName: 'table-vertical-column-cell',
    },
    {
      field: MAP_OPPORTUNITIES_OVERVIEW_FIELDS.GEOGRAPHY,
      headerName: OPPORTUNITIES_OVERVIEW.GEOGRAPHY,
      width: getColumnWidth(180, 220, 150),
      minWidth: 180,
      cellClassName: 'table-vertical-column-cell',
    },
    {
      field: MAP_OPPORTUNITIES_OVERVIEW_FIELDS.NO_OF_POSITIONS,
      headerName: OPPORTUNITIES_OVERVIEW.NO_OF_POSITIONS,
      width: getColumnWidth(165, 220, 180),
      minWidth: 170,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: MAP_OPPORTUNITIES_OVERVIEW_FIELDS.CLOSED_POSITIONS,
      headerName: OPPORTUNITIES_OVERVIEW.CLOSED_POSITIONS,
      width: getColumnWidth(170, 220, 180),
      minWidth: 170,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: MAP_OPPORTUNITIES_OVERVIEW_FIELDS.PENDING,
      headerName: OPPORTUNITIES_OVERVIEW.PENDING,
      width: getColumnWidth(170, 220, 200),
      minWidth: 170,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: MAP_OPPORTUNITIES_OVERVIEW_FIELDS.LOST_POSITIONS,
      headerName: OPPORTUNITIES_OVERVIEW.LOST_POSITIONS,
      width: getColumnWidth(160, 230, 200),
      minWidth: 160,
      align: 'center',
      headerAlign: 'center',
    },
    {
      field: MAP_OPPORTUNITIES_OVERVIEW_FIELDS.DROPPED_POSITIONS,
      headerName: OPPORTUNITIES_OVERVIEW.DROPPED_POSITIONS,
      width: getColumnWidth(180, 240, 200),
      minWidth: 180,
      align: 'center',
      headerAlign: 'center',
    },
  ];

  const sortFilterColumns = columns.map((col) => col.field);

  const handleDownloadExcel = async () => {
    try {
      const { startDate = '', endDate = '' } = opportunitiesDateRange;
      await getOpportunitiesOverviewReport(startDate, endDate);
    } catch (error) {
      snackbarOpen(
        STAFF_AUGMENTATION.DOWNLOAD_FAILURE_MESSAGE,
        STAFF_AUGMENTATION.ERROR_SEVERITY,
      );
    } finally {
      setAnchorEl(null);
    }
  };

  const handleDateRangeChange = (newDateRange) => {
    const { startDate, endDate } = newDateRange;

    const parsedStartDate = startDate ? new Date(startDate) : null;
    const parsedEndDate = endDate ? new Date(endDate) : null;

    if (parsedStartDate && isNaN(parsedStartDate)) {
      console.error('Invalid startDate in handleDateRangeChange:', startDate);
      return;
    }

    if (parsedEndDate && isNaN(parsedEndDate)) {
      console.error('Invalid endDate in handleDateRangeChange:', endDate);
      return;
    }

    if (parsedStartDate && parsedEndDate) {
      // Set the new date range
      setOpportunitiesDateRange({ startDate: parsedStartDate, endDate: parsedEndDate });
  
      // Fetch the opportunities overview data
      getOpportunitiesOverviewData(
        dayjs(parsedStartDate).format('YYYY-MM-DD'),
        dayjs(parsedEndDate).format('YYYY-MM-DD')
      );
    }
  };

  return (
    <div className="opportunities-overview-outer-container">
      <div className="opportunities-overview-filter-container">
        <div className="opportunities-overview-date-range-container">
          <DateRangeEditor
            key={`opportunity-overview-date-range-${opportunitiesDateRange.startDate}-${opportunitiesDateRange.endDate}`}
            dateRange={{
              startDate: opportunitiesDateRange.startDate ? new Date(opportunitiesDateRange.startDate) : null,
              endDate: opportunitiesDateRange.endDate ? new Date(opportunitiesDateRange.endDate) : null,
            }}
            onChange={(newDateRange) => handleDateRangeChange(newDateRange)}
            fromPlaceholder="From Date"
            toPlaceholder="To Date"
            definedRanges={defaultDateRanges}
            dateFormat="dd/mm/yyyy"
            useCurrentYear
            splitInitialCustomMonthView={true}
          />
          <div className="staff-aug-date-range-note">
            <strong className="staff-aug-date-heading">{DATE_NOTE_HEADING}</strong> {DATE_NOTE_DESCRIPTION}
          </div>
        </div>

        <div>
          <ButtonComponent
            label={STAFF_AUGMENTATION.DOWNLOAD}
            variant="text"
            onClick={(e) => setAnchorEl(e.currentTarget)}
            endIcon={<img src={ArrowDropDownIcon} alt="Dropdown Arrow" />}
            btnCss="download-button"
          />
          <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
            <MenuItem
              onClick={handleDownloadExcel}
              className="download-report-dropdown"
              onMouseEnter={() => setIsExcelHovered(true)}
              onMouseLeave={() => setIsExcelHovered(false)}
            >
              <img
                src={isExcelHovered ? ExcelHoverIcon : ExcelIcon}
                alt="Excel Icon"
                style={{ marginRight: 8 }}
              />
              Download as Excel
            </MenuItem>
          </Menu>
        </div>
      </div>

      <div className="opportunity-report-data-grid-container">
        <DataGridComponent
          dataRows={opportunitiesRows}
          dataColumns={columns}
          sortFilterColumns={sortFilterColumns}
          isFilteredRows={opportunitiesRows}
          pageSize={opportunitiesPageSize}
          isBackendPaginated={false}
          hideFooter
          hideSeparator
          dataGridCss="opportunity-overview-report-grid"
          sortingMode="server"
          paginationMode="server"
        />
      </div>
    </div>
  );
};

OpportunitiesOverviewReport.propTypes = {
  opportunitiesRows: PropTypes.array,
  initialDateRange: PropTypes.object,
  opportunitiesDateRange: PropTypes.object.isRequired,
  setOpportunitiesDateRange: PropTypes.func.isRequired,
  opportunitiesPageSize: PropTypes.number,
  getOpportunitiesOverviewData: PropTypes.func.isRequired,
};

export default OpportunitiesOverviewReport;
